export default "__VITE_ASSET__DYcFkQAB__"